module.exports = __webpack_public_path__ + "img/40_38_068_760.deb2e80a.jpg";